import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrums from "../../../common/breadcrumbs";
import { SWAL_SETTINGS } from "../../../../../utils/Constants";
import { globalLoader, handleServerValidations } from "../../../../../utils/commonfunction";
import * as categoryService from "../../../services/sub-categories.services";
import * as Yup from "yup";
import { Tooltip, Whisper, Loader } from "rsuite";
import { useTranslation } from "react-i18next";

const SubCategoriesEdit = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});
  const [previewimage, setPreviewImage] = useState("");
  const [allCategories, setAllCategories] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [saveType, setSaveType] = useState("");
  const { t } = useTranslation();

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("sidebar_link_categories"), url: "/admin/manage-categories/categories/list/1" },
    { title: t("btn_edit"), url: "" },
  ];

  useEffect(() => {
    categoryService
      .Details(params.id)
      .then((response) => {
        setShowDefault(response && response.data ? response.data : []);
        setPreviewImage(response.data.image);
        setTimeout(() => {
          setDataLoaded(true);
        }, 100);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, []);

  useEffect(() => {
    categoryService
      .all()
      .then((data) => {
        console.log(data.data);
        console.log(data.data.list);
        setAllCategories(data && data.data && data.data.list ? data.data.list : []);
      })
      .catch((error) => {
        console.log("error ====> ", error);
      });
  }, []);

  const validationSchema = Yup.object().shape({
    title: Yup.string()
      .trim()
      .required(t("label_title_error"))
      .max(50, t("max_length_label"))
      .test("no-spaces", t("label_title_error"), (value) => value.trim()),
    description: Yup.string().test("max-words", "Description must be at most 200 words", (value) => {
      if (!value) return true; // Allow empty description
      return value.trim().split(/\s+/).length <= 200;
    }),
  });

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {dataLoaded ? (
        <Formik
          enableReinitialize
          initialValues={{
            title: showdefault && showdefault.title ? showdefault.title : "",
            category: showdefault && showdefault?.category?._id ? showdefault.category._id : showdefault.category || "",
            description: showdefault && showdefault.description ? showdefault.description : "",
          }}
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting }) => {
            globalLoader(true);
            let formData = new FormData();
            formData.append("o_id", params.id);
            formData.append("title", values.title.trim());
            formData.append("category", values.category);
            formData.append("description", values.description.trim());
            categoryService
              .Edit(formData)
              .then((response) => {
                setSubmitting(false);
                if (response.success) {
                  Swal.fire({
                    icon: "success",
                    text: "Sub categories updated successfully",
                    ...SWAL_SETTINGS,
                  });
                  if (saveType !== "Save") {
                    setTimeout(() => {
                      navigate(`/admin/manage-categories/sub-categories/list/${params.pgno}`);
                    }, 1000);
                  }
                  globalLoader(false);
                } else {
                  Swal.fire({
                    icon: "error",
                    text: handleServerValidations(response),
                    ...SWAL_SETTINGS,
                  });
                }
                globalLoader(false);
              })
              .catch((error) => {
                console.log("error ====> ", error);
              });
          }}>
          {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, setFieldTouched, isSubmitting }) => (
            <form onSubmit={handleSubmit}>
              <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                  <div className="card custom-card">
                    <div className="card-body">
                      <div>
                        <h6 className="main-content-label mb-3">{t("btn_edit") + " " + t("sidebar_link_sub_categories")}</h6>
                      </div>
                      <div className="row row-sm">
                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="title" className="text-left d-flex">
                            {t("Title")}:<span className="requirestar">*</span>{" "}
                          </label>
                          <input name="title" id="title" type="text" onChange={handleChange} onBlur={handleBlur} value={values.title} className="form-control" />
                          <span className="text-danger d-flex text-left">{errors.title && touched.title && errors.title}</span>
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="category" className="text-left d-flex">
                            Category:<span className="requirestar">*</span>{" "}
                          </label>
                          <div className=" select-down-arrow">
                            <select name="category" id="category" onChange={handleChange} onBlur={handleBlur} value={values.category} className="form-control">
                              {allCategories.map((value, i) => {
                                return <option key={i} value={value._id}>{`${value.title}`}</option>;
                              })}
                            </select>
                          </div>
                          <span className="text-danger d-flex text-left">{errors.category && touched.category && errors.category}</span>
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label htmlFor="description" className="text-left d-flex">
                            {t("label_description")}:
                          </label>
                          <textarea name="description" id="description" type="text" onChange={handleChange} onBlur={handleBlur} value={values.description} className="form-control" cols={4} rows={4} />
                          <small className="text-muted d-flex justify-content-end">{values.description.trim().split(/\s+/).filter(Boolean).length} / 200 words</small>
                          <span className="text-danger d-flex text-left">{errors.description && touched.description && errors.description}</span>
                        </div>

                        {previewimage ? (
                          <ul className="question-image-preview questions-ul">
                            <li className="pr_img_box">
                              <img src={previewimage} style={{ height: "100px" }} alt={"img"} />
                              <div className="img_options">
                                <button
                                  type="button"
                                  className="text-danger"
                                  onClick={() => {
                                    // console.log(previewResImage , previewimage)
                                    setPreviewImage("");
                                    setFieldValue("image", null);
                                    document.getElementById("files").value = "";
                                  }}>
                                  <i className="ri-delete-bin-6-fill"></i>
                                </button>
                              </div>
                            </li>
                          </ul>
                        ) : (
                          ""
                        )}

                        <div className="">
                          <button
                            onClick={() => {
                              setSaveType("Save");
                            }}
                            className="btn btn-info mr-2"
                            type="submit">
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                            {t("btn_save")}
                          </button>
                          <button
                            onClick={() => {
                              setSaveType("");
                            }}
                            className="btn btn-success mr-2"
                            type="submit">
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                            {t("btn_save_exit")}
                          </button>
                          <button className="btn ripple btn-secondary" type="button" onClick={() => navigate(-1)}>
                            <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                            {t("btn_cancel")}
                          </button>
                        </div>
                      </div>
                      {/* // : "Loader"} */}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default SubCategoriesEdit;
